export default __webpack_public_path__ + "3323e83fa69589331d1384df13ee6027.png";